import { useCallback, useState } from 'react';

import { PrescriptionHistoryPanelFilters } from './PatientPrescriptionHistoryPanelFilters.types';

type PatientPrescriptionHistoryPanelFiltersResult = {
   filters: PrescriptionHistoryPanelFilters;
   handleIssuedByCurrentPractitionerChange: (value: boolean) => void;
   handleContinuouslyUsedMedicineChange: (value: boolean) => void;
};

export const usePatientPrescriptionHistoryPanelFilters = (): PatientPrescriptionHistoryPanelFiltersResult => {
   const [filters, setFilters] = useState<PrescriptionHistoryPanelFilters>({
      issuedByCurrentPractitioner: false,
      continuouslyUsedMedicine: false,
   });

   const handleIssuedByCurrentPractitionerChange = useCallback((value: boolean) => {
      setFilters((current) => ({ ...current, issuedByCurrentPractitioner: value }));
   }, []);

   const handleContinuouslyUsedMedicineChange = useCallback((value: boolean) => {
      setFilters((current) => ({ ...current, continuouslyUsedMedicine: value }));
   }, []);

   return {
      filters: filters,
      handleIssuedByCurrentPractitionerChange: handleIssuedByCurrentPractitionerChange,
      handleContinuouslyUsedMedicineChange: handleContinuouslyUsedMedicineChange,
   };
};
